<div class="acs-btn-container" [class.acs-btn-container--dropdown]="dropdown">
  <button 
    [type]="type"
    [disabled]="disabled || loading"
    [class]="'acs-btn acs-btn-' + variant + ' acs-btn-' + size"
    [class.acs-btn-full-width]="fullWidth"
    [class.acs-btn-loading]="loading"
    [class.acs-btn-dropdown]="dropdown"
    [class.acs-btn-dropdown--open]="dropdown && showDropdown"
    (click)="onClick($event)">
    <span class="acs-btn-content">
      <span class="acs-btn-spinner" *ngIf="loading"></span>
      <ng-content></ng-content>
      <span class="acs-btn-dropdown-arrow" *ngIf="dropdown" [class.acs-btn-dropdown-arrow--open]="showDropdown">▼</span>
    </span>
  </button>

  <div 
    class="acs-btn-dropdown-menu"
    [class.acs-btn-dropdown-menu--open]="dropdown && showDropdown"
    [class.acs-btn-dropdown-menu--right]="dropdownPosition === 'right'"
    *ngIf="dropdown">
    <button 
      *ngFor="let option of dropdownOptions"
      class="acs-btn-dropdown-option"
      [class.acs-btn-dropdown-option--disabled]="option.disabled"
      [disabled]="option.disabled"
      (click)="onDropdownOptionClick(option, $event)">
      <span class="acs-btn-dropdown-icon" *ngIf="option.icon">{{ option.icon }}</span>
      <span class="acs-btn-dropdown-label">{{ option.label }}</span>
    </button>
  </div>
</div>
